import { SET_CREATE_MAP_PINCODE_WITH_HFR, SET_GEOMETRY_MAP_POINT, SET_MAP_LAT_LONG, SET_MAP_MANUAL_ADDRESS, SET_MAP_MANUAL_LAT_LONG, SET_MAP_MANUAL_LAT_LONG_CLICKED, SET_MAP_PINCODE_FIRST_TIME_EDIT, SET_MAP_SERVICES_CREATE_POLYGON, SET_MAP_SERVICES_DOWN, SET_MAP_SERVICES_POLYGON_FOR_EDIT, facilityGeoMapActionType } from "@store/types/facilityGeoMapTypes";

export interface GeometryEngineState {
    mapPointer: any;
    distFenceGeometry: any;
    isManualAddress: any;
    locationData: any;
    isManualLatLong: any;
    isManualLatLongClicked: any;
    editFirstTimePincode: any;
    addPincodeWithHfr: any;
    mapServicesDown: any;
    createPolygone: any;
    polygoneForEdit: any;
};

export const initialState: GeometryEngineState = {
    mapPointer: null,
    distFenceGeometry: null,
    isManualAddress: false,
    locationData: null,
    isManualLatLong: false,
    isManualLatLongClicked: false,
    editFirstTimePincode: null,
    addPincodeWithHfr: null,
    mapServicesDown: false,
    createPolygone: false,
    polygoneForEdit: false
};

const facilityGeoMapReducer = (
    state = initialState,
    action: facilityGeoMapActionType,
): GeometryEngineState => {
    switch (action.type) {
        case SET_GEOMETRY_MAP_POINT:
            return { ...state, mapPointer: action.payload.mapPointer, distFenceGeometry: action.payload.distFenceGeometry };

        case SET_MAP_MANUAL_ADDRESS:
            return { ...state, isManualAddress: action.payload };

        case SET_MAP_LAT_LONG:
            return { ...state, locationData: action.payload };

        case SET_MAP_MANUAL_LAT_LONG:
            return { ...state, isManualLatLong: action.payload };
        case SET_MAP_MANUAL_LAT_LONG_CLICKED:
            return { ...state, isManualLatLongClicked: action.payload };
        case SET_MAP_PINCODE_FIRST_TIME_EDIT:
            return { ...state, editFirstTimePincode: action.payload };
        case SET_CREATE_MAP_PINCODE_WITH_HFR:
            return { ...state, addPincodeWithHfr: action.payload };
        case SET_MAP_SERVICES_DOWN:
            return { ...state, mapServicesDown: action.payload };
        case SET_MAP_SERVICES_CREATE_POLYGON:
            return { ...state, createPolygone: action.payload };
        case SET_MAP_SERVICES_POLYGON_FOR_EDIT:
            return { ...state, polygoneForEdit: action.payload };
        default:
            return state;
    }
};

export default facilityGeoMapReducer;